import { render, staticRenderFns } from "./DodatniSadrzajDetails.vue?vue&type=template&id=619cc91e&scoped=true&"
import script from "./DodatniSadrzajDetails.vue?vue&type=script&lang=js&"
export * from "./DodatniSadrzajDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619cc91e",
  null
  
)

export default component.exports